import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

import FeatureItem from './FeatureItem';
import giftBoxIcon from 'public/icons/gift-box.svg';
import notebookIcon from 'public/icons/notebook.svg';
import truckIcon from 'public/icons/truck.svg';
import { MIN_FREE_DELIVERY_PRICE } from 'domain/constants';

const Features: React.FC = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <FeatureItem
        title="Подарункове пакування"
        subtitle="для планерів на кільцях та замовлень від 1000 грн"
        hasDivider
        icon={giftBoxIcon}
      />

      <FeatureItem
        title="Безкоштовна доставка"
        subtitle={`від ${MIN_FREE_DELIVERY_PRICE} грн`}
        hasDivider
        icon={truckIcon}
      />

      <FeatureItem
        title="Корпоративні замовлення"
        subtitle="брендованої продукції"
        icon={notebookIcon}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gap: `${theme.spacing(4)}px ${theme.spacing(4)}px`,
      gridTemplateColumns: '1fr 1fr 1fr',
      marginBottom: theme.spacing(17)
    }
  }
}));

export default Features;
